import { Button } from '@/components/ui/button'
import { useAuth } from '@/lib'
import { cn } from '@/lib/utils'
import { type AuthUserOutputDataRecruitingVolume } from '@jobilla/nexus-sdk'
import { useTranslation } from 'react-i18next'
import { ScreenHeading } from './screen-heading'

const OPTIONS: { value: AuthUserOutputDataRecruitingVolume; labelKey: string }[] = [
	{ value: 'low', labelKey: 'onboarding.recruitingVolume.option.low' },
	{ value: 'mid', labelKey: 'onboarding.recruitingVolume.option.mid' },
	{ value: 'high', labelKey: 'onboarding.recruitingVolume.option.high' },
	{ value: 'unknown', labelKey: 'onboarding.recruitingVolume.option.unknown' },
]

type Props = {
	onSubmit: (value: AuthUserOutputDataRecruitingVolume) => void
	isSubmitting: boolean
}

export function RecruitingVolumeScreen({ onSubmit, isSubmitting }: Props) {
	const { t } = useTranslation()
	const { user } = useAuth()
	const current = user?.recruitingVolume ?? null

	return (
		<>
			<img src="/onboarding/recruiting-volume.png" alt="" className="mx-auto max-h-40 w-auto" />
			<ScreenHeading
				title={t('onboarding.recruitingVolume.title')}
				subtitle={t('onboarding.recruitingVolume.subtitle')}
			/>
			<div className="grid grid-cols-2 gap-3">
				{OPTIONS.map(option => (
					<Button
						key={option.value}
						variant={current === option.value ? 'default' : 'outline'}
						disabled={isSubmitting}
						onClick={() => onSubmit(option.value)}
						className={cn(
							'h-14',
							current === option.value && 'bg-brand-600 hover:bg-brand-700 text-white border-brand-600',
						)}
					>
						{t(option.labelKey)}
					</Button>
				))}
			</div>
		</>
	)
}
